import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Phases_getInstance27czzec4fvnke as Phases_getInstance } from '../../request/HttpRequestPipeline.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isSuspendFunction153vlp5l2npj9 as isSuspendFunction } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Plugin_getInstance305tjh8i5k0u9 as Plugin_getInstance } from '../HttpSend.mjs';
import { plugin3vxt624hnu3pv as plugin } from '../HttpClientPlugin.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function SetupRequest$install$slambda($handler) {
  return constructCallableReference(function *($this$intercept, it, $completion) {
    yield* $handler($this$intercept.t4s_1, $completion);
    return Unit_instance;
  }, 2);
}
var SetupRequestClass;
function SetupRequest() {
  if (SetupRequestClass === VOID) {
    class $ {
      p5s(client, handler) {
        var tmp = Phases_getInstance().e5m_1;
        client.c5g_1.x4s(tmp, SetupRequest$install$slambda(handler));
      }
      j5m(client, handler) {
        return this.p5s(client, (!(handler == null) ? isSuspendFunction(handler, 1) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'SetupRequest');
    SetupRequestClass = $;
  }
  return SetupRequestClass;
}
var SetupRequest_instance;
function SetupRequest_getInstance() {
  return SetupRequest_instance;
}
var SenderClass;
function Sender() {
  if (SenderClass === VOID) {
    class $ {
      constructor(httpSendSender, coroutineContext) {
        this.v5o_1 = httpSendSender;
        this.w5o_1 = coroutineContext;
      }
      bw() {
        return this.w5o_1;
      }
      *x5o(requestBuilder, $completion) {
        return yield* this.v5o_1.v5q(requestBuilder, $completion);
      }
    }
    initMetadataForClass($, 'Sender', VOID, VOID, VOID, [1]);
    SenderClass = $;
  }
  return SenderClass;
}
function Send$install$slambda($handler, $client) {
  return constructCallableReference(function *($this$intercept, request, $completion) {
    return yield* $handler(new (Sender())($this$intercept, $client.b5g_1), request, $completion);
  }, 2);
}
var SendClass;
function Send() {
  if (SendClass === VOID) {
    class $ {
      q5s(client, handler) {
        var tmp = plugin(client, Plugin_getInstance());
        tmp.l5r(Send$install$slambda(handler, client));
      }
      j5m(client, handler) {
        return this.q5s(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'Send');
    SendClass = $;
  }
  return SendClass;
}
var Send_instance;
function Send_getInstance() {
  return Send_instance;
}
//region block: init
SetupRequest_instance = new (SetupRequest())();
Send_instance = new (Send())();
//endregion
//region block: exports
export {
  Send_instance as Send_instance3jwyi367vhqvc,
  SetupRequest_instance as SetupRequest_instancezsckteg7b0pk,
};
//endregion

//# sourceMappingURL=CommonHooks.mjs.map
